import {
	SET_ACTIVE_STEP,
} from '../actions/activeStepActions'

const initialState = {
	activeStep: 0
}

export default function activeStepReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_STEP:
			// Select activeRoom manually
			return {
				...state,
				activeStep: action.payload,
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activeStepReducers.js